import {
    Button,
    Dialog,
    DialogActions, DialogContent, DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import Filter from "@mui/icons-material/Filter";
import {useState} from "react";

import Check from "@mui/icons-material/Check";
import {FilterItem} from "./registrations/reg_grid_slice";

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import styled from "@emotion/styled";

interface FilterSwitcherProps {
    onChange: (filterList: Set<FilterItem>) => void
    availableFilters: Set<FilterItem>
    enabled: Set<FilterItem>
    active: Set<FilterItem>
}

const Checked = ({checked}: { checked: boolean }) => {

    return <ListItemIcon>
        {checked ? <Check/> : <CheckBoxOutlineBlankIcon/>}
    </ListItemIcon>
}

const Li = styled(ListItem)({
    paddingLeft: "1em",
    paddingRight: "1em",
    paddingTop: 0,
    paddingBottom:0
})


export default ({availableFilters, onChange, enabled, active}: FilterSwitcherProps) => {

    const [open, setOpen] = useState(false)
    const isAvailable = (filter: FilterItem): boolean => availableFilters.has(filter)
    const isEnabled = (filter: FilterItem): boolean => enabled.has(filter)

    const toggle = (filter: FilterItem) => {
        if (enabled.has(filter)) {
            enabled.delete(filter)
        } else {
            enabled.add(filter)
        }
        onChange(enabled)

    }

    return <>
        <IconButton onClick={() => {
            setOpen(true)
        }}><Filter/></IconButton>
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Izberi filter</DialogTitle>
            <List>

                {isAvailable("product") &&
                    <Li>
                        <ListItemButton disabled={active.has("product")} onClick={() => toggle("product")}>
                            <Checked checked={isEnabled("product")}/>
                            <ListItemText> Izdelek</ListItemText></ListItemButton>
                    </Li>}
                {isAvailable("workOrder") &&
                    <Li>
                        <ListItemButton disabled={active.has("workOrder")} onClick={() => toggle("workOrder")}>
                            <Checked checked={isEnabled("workOrder")}/>
                            <ListItemText>Delovni nalog</ListItemText>
                        </ListItemButton>
                    </Li>}
                {isAvailable("machine") &&
                    <Li>
                        <ListItemButton disabled={active.has("machine")} onClick={() => toggle("machine")}>
                            <Checked checked={isEnabled("machine")}/>
                            <ListItemText>Stroj</ListItemText>
                        </ListItemButton>
                    </Li>}
                {isAvailable("partner") &&
                    <Li>
                        <ListItemButton disabled={active.has("partner")} onClick={() => toggle("partner")}>
                            <Checked checked={isEnabled("partner")}/>
                            <ListItemText>Partner</ListItemText>
                        </ListItemButton>
                    </Li>}
                {isAvailable("operation") &&
                    <Li>
                        <ListItemButton disabled={active.has("operation")} onClick={() => toggle("operation")}>
                            <Checked checked={isEnabled("operation")}/>
                            <ListItemText>Operacija</ListItemText>
                        </ListItemButton>
                    </Li>}
                {isAvailable("worker") &&
                    <Li>
                        <ListItemButton disabled={active.has("worker")} onClick={() => toggle("worker")}>
                            <Checked checked={isEnabled("worker")}/>
                            <ListItemText>Delavec</ListItemText>
                        </ListItemButton>
                    </Li>}
            </List>

            <DialogActions>
                <Button onClick={() => onChange(availableFilters)}>All</Button>
                <Button onClick={() => onChange(new Set())}>Clear</Button>
                <Button onClick={() => setOpen(false)}>OK</Button>
            </DialogActions>
        </Dialog>
    </>
}